import axios from "axios";
import { environment } from "../../environments/environment";
import { BankAgent_URL, FRAUD_RISK_CONFIGURATION_URL,Receive_Partner_URL } from "../../constants/backendUrl";
import { COUNTRY_URL } from "../../constants/backendUrl";
import { DeliveryPartner } from "../../components/AgentMaster/modals/UpdateDeliveryAgent/types";

export class ManageAgent {
	private static URL: any = environment.partnerApiUrl;

	public static addAgent(data: any) {
		let UserURL: string = `${this.URL}/${BankAgent_URL.addBankAgent}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.post<any>(UserURL, data, config);
	}

	public static updateAgent(data: any) {
		let UserURL: string = `${this.URL}/${BankAgent_URL.updateBankAgent}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.put<any>(UserURL, data, config);
	}

	public static getAgent = (PageNumber: number, RowsOfPage: number, Key: any, Column: any) => {
		let UserURL: string = `${this.URL}/${BankAgent_URL.getBankagentList}?PageNumber=${PageNumber}&RowsOfPage=${RowsOfPage}&Slug=${Key}&Column=${Column}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	};


	public static deleteAgent(id: number) {
		let UserURL: string = `${this.URL}/${BankAgent_URL.deleteBankAgent}/${id}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.delete<any>(UserURL, config);
	}

	public static getCoutry = () => {
		let UserURL: string = `${this.URL}/${COUNTRY_URL.getCountry}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	};

	public static getAllCountry = () => {
		let UserURL: string = `${this.URL}/${COUNTRY_URL.getAllCountryList}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	};

	public static getAllCountryDeleted(id: any, isDeleted: any) {
		// ////console.log(isEncryption);
		let PartnerURL: string = `${this.URL}/${COUNTRY_URL.deleteFromAllCountryById}?id=${id} && IsDeleted=${isDeleted}`;

		// let PartnerURL: string = `${this.URL}/partner/id?id=${id}&status=${changeStatusEn}&encryption=${null}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.delete<any>(PartnerURL, config);
	}

	public static getRiskRating() {
		let UserURL: string = `${this.URL}/${FRAUD_RISK_CONFIGURATION_URL.getRiskRating}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	}

	public static updateCountryRiskRating(countryId: number, riskId: number) {
		let UserURL: string = `${this.URL}/${COUNTRY_URL.updateCountryRiskRating}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.put<any>(UserURL, { id: countryId, riskId }, config);
	}

	public static getReceiverPartnerDetails = () => {
		let UserURL: string =`${this.URL}/${Receive_Partner_URL.getReceivePartnersList}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.post<DeliveryPartner[]>(UserURL,{}, config);
	};

	public static updateReceiverPartnerAgent(data: any) {
		let UserURL: string = `${this.URL}/${Receive_Partner_URL.updateReceivePartnerAgents}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.post<any>(UserURL, data, config);
	}
}
